import { CRUDApiService } from "./impl/CRUDApiService";

export class CategoryApiService extends CRUDApiService {
  constructor() {
    super('categories');
  }
}
